function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgLogoTwitter(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "uc-social"
  }, props), React.createElement("path", {
    fill: "#1D9BF0",
    d: "M20.748 8.287c.013.194.013.388.013.584 0 5.964-4.54 12.842-12.842 12.842v-.003A12.778 12.778 0 011 19.686a9.063 9.063 0 006.68-1.87 4.52 4.52 0 01-4.217-3.135c.677.13 1.374.104 2.038-.078a4.514 4.514 0 01-3.62-4.424v-.057c.627.35 1.33.543 2.048.565A4.52 4.52 0 012.532 4.66a12.81 12.81 0 009.302 4.716 4.519 4.519 0 017.692-4.117c1.01-.2 1.98-.57 2.866-1.096a4.53 4.53 0 01-1.984 2.496A8.977 8.977 0 0023 5.95a9.17 9.17 0 01-2.252 2.338z"
  }));
}

SvgLogoTwitter.clsName = 'icon-uc-social__logo-twitter';
SvgLogoTwitter.remarkName = 'unknown';
export default SvgLogoTwitter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/uc-social/svgr/LogoTwitter.js
// module id = 2260
// module chunks = 17 18